module.exports = require('./dist/react-coverflow');